var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLeadImg01(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 91,
    height: 91,
    viewBox: "0 0 91 91",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("foreignObject", {
    x: -36.4,
    y: -36.4,
    width: 163.8,
    height: 163.8
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(18.2px)",
      clipPath: "url(#bgblur_0_7581_20280_clip_path)",
      height: "100%",
      width: "100%"
    }
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-figma-bg-blur-radius": 36.4
  }, /*#__PURE__*/React.createElement("rect", {
    width: 91,
    height: 91,
    rx: 13.7358,
    fill: "#EC9327",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.8116 26.7354C45.9719 26.7354 50.1939 30.9574 50.1939 36.1177C50.1939 41.278 45.9719 45.5001 40.8116 45.5001C35.6513 45.5001 31.4292 41.278 31.4292 36.1177C31.4292 30.9574 35.6513 26.7354 40.8116 26.7354ZM57.2307 66.6104L61.4528 70.762C62.6256 71.9348 64.2675 70.9966 64.2675 69.6127V59.5736L70.8351 51.5986C71.0965 51.2501 71.2556 50.8357 71.2948 50.4019C71.3339 49.968 71.2514 49.5319 71.0566 49.1423C70.8618 48.7526 70.5623 48.425 70.1918 48.196C69.8212 47.9669 69.3942 47.8456 68.9586 47.8456H52.5395C50.6631 47.8456 49.4903 50.1912 50.6631 51.5986L57.2307 59.5736V66.6104ZM52.5395 61.2155L47.1447 54.6479C46.2064 53.4751 45.7373 52.0677 45.7373 50.6604C44.0954 50.1912 42.4535 50.1912 40.8116 50.1912C30.491 50.1912 22.0469 54.4133 22.0469 59.5736V64.2648H52.5395V61.2155Z",
    fill: "#EC9327"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "bgblur_0_7581_20280_clip_path",
    transform: "translate(36.4 36.4)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 91,
    height: 91,
    rx: 13.7358
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeadImg01);
export default __webpack_public_path__ + "static/media/lead-img01.68dfb53a6e31ef472654d1117855f10e.svg";
export { ForwardRef as ReactComponent };